// extracted by mini-css-extract-plugin
module.exports = {"loader":"LoadingSkeleton_loader__3fB2Q","animate":"LoadingSkeleton_animate__3rY1l","load":"LoadingSkeleton_load__1B4GM"};